/*-------------------------------------------------------------------
グローバル変数
--------------------------------------------------------------------*/
let headerHeight;

/*-------------------------------------------------------------------
ドロワー：ボディスクロールロック
--------------------------------------------------------------------*/
function enableBodyScroll() {
  const scrollY = document.body.dataset.scrollY || "0";
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.width = "";
  document.body.style.marginRight = "";
  window.scrollTo(0, parseInt(scrollY, 10));
  delete document.body.dataset.scrollY;
}

/*-------------------------------------------------------------------
関数定義
--------------------------------------------------------------------*/
/**
 * スムーススクロール共通処理
 * @param {string} targetId - スクロール先のセレクタ
 * @param {number} speed - アニメーション速度（デフォルト: 500）
 * @param {number} offset - オフセット値（デフォルト: headerHeight）
 */
function smoothScrollTo(targetId, speed = 500, offset = null) {
  const target = jQuery(targetId);
  if (!target.length) return;

  let position = target.offset().top;
  const adjustOffset = offset !== null ? offset : headerHeight;

  // ヘッダーの固定状態に応じて位置を調整
  if (("fixed" === jQuery("#header").css("position")) || ("sticky" === jQuery("#header").css("position"))) {
    position -= adjustOffset;
  }

  // 負の値にならないようにする
  if (position < 0) {
    position = 0;
  }

  jQuery("html, body").animate({ scrollTop: position }, speed);
}

/**
 * アンカーリンク
*/
function scrollHash() {
  const hash = location.hash;
  if (hash && jQuery(hash).length) {
    // 一旦トップに戻してから目的地にスクロール
    window.scrollTo(0, 0);
    setTimeout(() => {
      smoothScrollTo(hash, 500);
    }, 300);
  }
}


/*-------------------------------------------------------------------
読み込み時実行
--------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  headerHeight = document.querySelector('.js-header').offsetHeight;
});


/*-------------------------------------------------------------------
イベント
--------------------------------------------------------------------*/
/**
 * スクロールバーを除いた画面幅の取得
 */
jQuery(window).on('load resize', function () {
  let vw = document.body.clientWidth;// スクロールバーを除いた幅を取得
  let vh = window.innerHeight; // アドレスバーを覗いた画面高さ
  headerHeight = document.querySelector('.js-header').offsetHeight;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
});


/**
 * フェードしたページに戻るときに白飛びする対応
 */
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});

jQuery(function () {
  // ページロード完了後にスクロールハッシュを実行
  jQuery(window).on('load', function() {
    scrollHash();
  });
  // 画面遷移
  window.addEventListener('beforeunload', function (e) {
    document.body.classList.add("fadeOut");
    setTimeout(() => {
      window.location = url;
    }, 500);
  });

  /* ドロワー */
  jQuery(".js-drawer").on("click", function (event) {
    event.preventDefault();
    const ariaControls = jQuery(this).attr("aria-controls");
    const addClass = 'is-opened'

    if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
      jQuery(`#${ariaControls}`).removeClass(addClass);
    } else {
      jQuery(`#${ariaControls}`).addClass(addClass);
    }

    jQuery(`[aria-controls=${ariaControls}]`).each(function () {
      jQuery(this).attr("aria-expanded", (jQuery(`#${ariaControls}`).hasClass(addClass) ? 'false' : 'true'));
      if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
        jQuery(this).addClass(addClass);
      } else {
        jQuery(this).removeClass(addClass);
      }
    });

    // inert 属性でフォーカス到達を完全遮断（aria-hidden-focus 対応・2026-05-20 NorthGoJapan 由来）
    if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
      // 開いた → inert 解除
      jQuery(`#${ariaControls}`).removeAttr('inert');
    } else {
      // 閉じた → inert 付与
      jQuery(`#${ariaControls}`).attr('inert', '');
    }

    // ドロワー開時にbody要素をfixedで固定（スクロール位置を保持）
    // toggle 後 → hasClass(addClass) が true = 開いた状態 / false = 閉じた状態
    if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
      // 開いた → disableBodyScroll（body fixed で背景固定）
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = `calc(100% - ${scrollbarWidth}px)`;
      document.body.style.marginRight = `${scrollbarWidth}px`;
      document.body.dataset.scrollY = String(scrollY);
    } else {
      // 閉じた → enableBodyScroll（body の固定解除 + 元のスクロール位置へ）
      enableBodyScroll();
    }

    return false;
  });

  /**
   * ドロワー内のページ内リンククリック時に閉じる
   */
  jQuery('#drawer-content1 a[href*="#"]').on('click', function (event) {
    const currentUrl = location.protocol + '//' + location.host + location.pathname; // 現在のURL
    const href = jQuery(this).prop("href");
    const hrefUrl = href.split('#')[0];   // リンク先のURL

    if (currentUrl == hrefUrl) {
      jQuery('.for-drawer').removeClass('is-opened');
      jQuery('#drawer-content1').attr('aria-hidden', true).attr('inert', '');
      enableBodyScroll();
    }
  });

  /* ヘッダ */
  jQuery(window).on('load scroll', function () {
    // if (jQuery('body').hasClass('home')) {
    const $header = jQuery('.js-header');
    if ($header.length) {
      const target = jQuery(`.${jQuery($header).data('target')}`);
      const targetHeight = (target.length ? target.innerHeight() : headerHeight * 1.1);
      let position = jQuery(this).scrollTop();
      if (position > targetHeight) {
        $header.addClass('is-fixed');
      } else if (position == 0) {
        $header.removeClass('is-fixed');
      }
    }
    // }
  });


  /* スムーススクロール */
  jQuery(document).on('click', 'a[href*="#"]:not(".js-tabIndex, .js-modal, .js-accordion, .toc_toggle a")', function (e) {
    const currentUrl = location.protocol + '//' + location.host + location.pathname.replace(/\/$/, ''); // 現在のURL
    const href = jQuery(this).prop("href");
    const hrefUrl = href.split('#')[0].replace(/\/$/, '');   // リンク先のURL

    if (currentUrl == hrefUrl) {
      e.preventDefault();
      let id = '#' + href.split('#')[1];  // リンク先のアンカー
      const targetId = "#" === id ? "html" : id;
      smoothScrollTo(targetId, 500);
      jQuery(this).blur();
    }
  });

  /* 電話リンク */
  let $ua = navigator.userAgent;
  if ($ua.indexOf("iPhone") < 0 && $ua.indexOf("Android") < 0) {  // PCのとき
    jQuery('a[href^="tel:"]') // 電話リンク
      .css("cursor", "default") // カーソルをポインターにしない
      .css('pointer-events', 'none')  // ホバーなども動作しない
      .on("click", function (e) {
        e.preventDefault();
      });
  }

  /* ドロワー：Escapeキーで閉じる */
  jQuery(document).on('keydown', function (event) {
    if (event.key === 'Escape' && jQuery('#drawer-content1').hasClass('is-opened')) {
      jQuery('.for-drawer').removeClass('is-opened');
      jQuery('#drawer-content1').attr('aria-hidden', true).attr('inert', '');
      jQuery('[aria-controls="drawer-content1"]').attr('aria-expanded', 'false').removeClass('is-opened');
      enableBodyScroll();
    }
  });

  /* ドロワー：フォーカストラップ（静的メニュー使用時のみ有効） */
  const focusTrap = document.getElementById('js-focus-trap');
  const hamburgerBtn = document.querySelector('.js-drawer[aria-controls="drawer-content1"]');
  if (focusTrap && hamburgerBtn) {
    focusTrap.addEventListener('focus', function () {
      hamburgerBtn.focus();
    });
  }

  /* p-schedule SP アコーディオン：トグルクリックで data-state を切り替え
   * 閉じる時は「開く前のトグルボタンの画面位置」に戻す（ビューポート上端からの相対位置を再現） */
  let savedToggleViewportTop = 0;
  jQuery('.js-scheduleToggle').on('click', function () {
    const $btn = jQuery(this);
    const $list = jQuery('#' + $btn.attr('aria-controls'));
    const isOpen = $btn.attr('aria-expanded') === 'true';
    const newState = !isOpen;

    if (!isOpen) {
      // 開く直前：トグルボタンのビューポート上端からの位置を記憶
      savedToggleViewportTop = $btn[0].getBoundingClientRect().top;
    }

    $btn.attr('aria-expanded', String(newState));
    $list.attr('data-state', newState ? 'open' : 'closed');

    // 閉じる時：DOM 縮小後に、トグルボタンが開く前と同じビューポート位置になるよう scrollY を調整
    if (isOpen) {
      requestAnimationFrame(function () {
        const currentTop = $btn[0].getBoundingClientRect().top;
        const diff = currentTop - savedToggleViewportTop;
        window.scrollBy(0, diff);
      });
    }
  });
});
